/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. A percentage increase is only capped at 100% if the value exactly doubles. If a value more than doubles — say from 40 to 100 — the increase is 150%, since ((100 − 40) ÷ 40) × 100 = 150. There's no upper limit; increases can run into the thousands of percent for very fast growth.`)
};

const es_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Un aumento porcentual solo llega justo al 100% si el valor se duplica exactamente. Si un valor se multiplica por más del doble — por ejemplo, de 40 a 100 — el aumento es del 150%, ya que ((100 − 40) ÷ 40) × 100 = 150. No hay un límite superior; los aumentos pueden llegar a miles por ciento en crecimientos muy rápidos.`)
};

const de_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Ein prozentualer Anstieg liegt nur dann bei genau 100%, wenn sich der Wert exakt verdoppelt. Verdoppelt sich ein Wert mehr als das — etwa von 40 auf 100 —, beträgt der Anstieg 150%, da ((100 − 40) ÷ 40) × 100 = 150. Es gibt keine Obergrenze; bei sehr schnellem Wachstum können Anstiege in die Tausende Prozent gehen.`)
};

const nl_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Een percentagestijging komt alleen op 100% uit als de waarde exact verdubbelt. Als een waarde meer dan verdubbelt — bijvoorbeeld van 40 naar 100 — is de stijging 150%, want ((100 − 40) ÷ 40) × 100 = 150. Er is geen bovengrens; bij zeer snelle groei kunnen stijgingen oplopen tot duizenden procenten.`)
};

const fr_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Une augmentation en pourcentage n’est plafonnée à 100 % que si la valeur double exactement. Si une valeur fait plus que doubler — par exemple de 40 à 100 — l’augmentation est de 150 %, puisque ((100 − 40) ÷ 40) × 100 = 150. Il n’y a pas de limite supérieure ; les augmentations peuvent atteindre des milliers de pour cent pour une croissance très rapide.`)
};

const it_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Un aumento percentuale è limitato al 100% solo se il valore raddoppia esattamente. Se un valore più che raddoppia — ad esempio da 40 a 100 — l'aumento è del 150%, poiché ((100 − 40) ÷ 40) × 100 = 150. Non c'è un limite superiore; gli aumenti possono arrivare a migliaia di punti percentuali per una crescita molto rapida.`)
};

const pt_br2_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Um aumento percentual só é limitado a 100% se o valor exatamente dobrar. Se um valor mais que dobra — digamos, de 40 para 100 — o aumento é de 150%, já que ((100 − 40) ÷ 40) × 100 = 150. Não há limite superior; aumentos podem chegar a milhares de por cento em crescimentos muito rápidos.`)
};

const pt_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Um aumento percentual só fica limitado a 100% se o valor duplicar exatamente. Se um valor mais do que duplicar — por exemplo, de 40 para 100 — o aumento é de 150%, já que ((100 − 40) ÷ 40) × 100 = 150. Não há limite superior; os aumentos podem chegar a milhares por cento em crescimentos muito rápidos.`)
};

const ja_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。パーセント増加が100%になるのは、値がちょうど2倍になったときだけです。値が2倍以上になった場合 — 例えば40から100へ変化した場合 — 増加率は150%になります。((100 − 40) ÷ 40) × 100 = 150だからです。上限はなく、非常に急成長する場合には増加率が数千パーセントに達することもあります。`)
};

const zh_pct_increase_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。只有当数值恰好翻倍时，百分比增长才等于 100%。如果数值增长超过一倍——比如从 40 到 100——增长就是 150%，因为 ((100 − 40) ÷ 40) × 100 = 150。百分比增长没有上限；极快的增长可以达到数千个百分点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq3_a", locale)
	if (locale === "en") return en_pct_increase_faq3_a(inputs)
	if (locale === "es") return es_pct_increase_faq3_a(inputs)
	if (locale === "de") return de_pct_increase_faq3_a(inputs)
	if (locale === "nl") return nl_pct_increase_faq3_a(inputs)
	if (locale === "fr") return fr_pct_increase_faq3_a(inputs)
	if (locale === "it") return it_pct_increase_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq3_a(inputs)
	if (locale === "pt") return pt_pct_increase_faq3_a(inputs)
	if (locale === "ja") return ja_pct_increase_faq3_a(inputs)
	return zh_pct_increase_faq3_a(inputs)
};